// src/document-types.ts
var DocumentResourceType = /* @__PURE__ */ ((DocumentResourceType2) => {
  DocumentResourceType2["AIRLINE"] = "Airline";
  DocumentResourceType2["AIRCRAFT"] = "Aircraft";
  DocumentResourceType2["CREW_MEMBER"] = "CrewMember";
  DocumentResourceType2["STATION_MANAGER_COUNTRY"] = "StationManagerCountry";
  DocumentResourceType2["CHARTER"] = "Charter";
  DocumentResourceType2["APPLICATION"] = "Application";
  DocumentResourceType2["CARGO"] = "Cargo";
  DocumentResourceType2["CODE_SHARE"] = "CodeShare";
  DocumentResourceType2["PAYMENT"] = "Payment";
  return DocumentResourceType2;
})(DocumentResourceType || {});
var DOCUMENT_TYPES = {
  airOperatorCertificate: {
    name: "airOperatorCertificate",
    label: "Air Operator Certificate",
    description: "Document for Air Operator Certificate",
    type: "any",
    resourceType: "Airline" /* AIRLINE */,
    hasExpirationDate: false
  },
  operationsSpecifications: {
    name: "operationsSpecifications",
    label: "Operations specifications",
    description: "Specifications for operations",
    type: "any",
    resourceType: "Airline" /* AIRLINE */,
    hasExpirationDate: false
  },
  accidentsList: {
    name: "accidentsList",
    label: "The list of the accidents/incidents",
    description: "List of recorded accidents or incidents",
    type: "any",
    resourceType: "Airline" /* AIRLINE */,
    hasExpirationDate: false
  },
  certificateOfAirworthiness: {
    name: "certificateOfAirworthiness",
    label: "CofA Certificate of airworthiness",
    description: "Document for airworthiness certification",
    type: "any",
    resourceType: "Aircraft" /* AIRCRAFT */,
    hasExpirationDate: true
  },
  certificateOfRegistration: {
    name: "certificateOfRegistration",
    label: "CofR - Certificate of Registration",
    description: "Document for registration certificate",
    type: "any",
    resourceType: "Aircraft" /* AIRCRAFT */,
    hasExpirationDate: true
  },
  airworthinessReviewCertificate: {
    name: "airworthinessReviewCertificate",
    label: "Airworthiness Review Certificate",
    description: "ARC Review certificate for airworthiness",
    type: "any",
    resourceType: "Aircraft" /* AIRCRAFT */,
    hasExpirationDate: true
  },
  noiseCertificate: {
    name: "noiseCertificate",
    label: "Noise Certificate",
    description: "Document certifying noise levels",
    type: "any",
    resourceType: "Aircraft" /* AIRCRAFT */,
    hasExpirationDate: true
  },
  certificateOfInsurance: {
    name: "certificateOfInsurance",
    label: "Certificate of insurance (towards passengers, baggage, cargo, and third-party legal liabilities)",
    description: "Insurance certificate",
    type: "any",
    resourceType: "Aircraft" /* AIRCRAFT */,
    hasExpirationDate: true
  },
  certificateOfInsuranceOther: {
    name: "certificateOfInsuranceOther",
    label: "Certificate of insurance - other",
    description: "Other types of insurance certificate",
    type: "any",
    resourceType: "Aircraft" /* AIRCRAFT */,
    hasExpirationDate: true
  },
  radioLicense: {
    name: "radioLicense",
    label: "Radio license",
    description: "Radio license document",
    type: "any",
    resourceType: "Aircraft" /* AIRCRAFT */,
    hasExpirationDate: true
  },
  fleetStatement: {
    name: "fleetStatement",
    label: "Fleet statement",
    description: "Document for fleet statement",
    type: "any",
    resourceType: "Aircraft" /* AIRCRAFT */,
    hasExpirationDate: false
  },
  aerodromeOperatingMinimaStatement: {
    name: "aerodromeOperatingMinimaStatement",
    label: "Aerodrome Operating Minima - Statement",
    description: "Statement for aerodrome operating minima",
    type: "any",
    resourceType: "Aircraft" /* AIRCRAFT */,
    hasExpirationDate: false
  },
  leaseAgreement: {
    name: "leaseAgreement",
    label: "Lease agreement",
    description: "Lease agreement document",
    type: "any",
    resourceType: "Aircraft" /* AIRCRAFT */,
    hasExpirationDate: false
  },
  passport: {
    name: "passport",
    label: "Passport",
    description: "Passport",
    type: "any",
    resourceType: "CrewMember" /* CREW_MEMBER */,
    hasExpirationDate: false
  },
  license: {
    name: "license",
    label: "License",
    description: "License",
    type: "any",
    resourceType: "CrewMember" /* CREW_MEMBER */,
    hasExpirationDate: false
  },
  id: {
    name: "id",
    label: "ID",
    description: "ID",
    type: "any",
    resourceType: "CrewMember" /* CREW_MEMBER */,
    hasExpirationDate: false
  },
  powerOfAttorneyForRepresentative: {
    name: "powerOfAttorneyForRepresentative",
    label: "Power of Attorney for representative",
    description: "Document granting power of attorney",
    type: "any",
    resourceType: "StationManagerCountry" /* STATION_MANAGER_COUNTRY */,
    hasExpirationDate: false
  },
  charterAgreement: {
    name: "charterAgreement",
    label: "Charter Agreement",
    description: "Document for charter agreements",
    type: "any",
    resourceType: "Charter" /* CHARTER */,
    hasExpirationDate: false
  },
  slot: {
    name: "slot",
    label: "SLOT",
    description: "SLOT document",
    type: "any",
    resourceType: "Application" /* APPLICATION */,
    hasExpirationDate: false
  },
  officialLetter: {
    name: "officialLetter",
    label: "Official letter",
    description: "Official letter document",
    type: "any",
    resourceType: "Application" /* APPLICATION */,
    hasExpirationDate: false
  },
  applicationForApproval: {
    name: "applicationForApproval",
    label: "Application for approval",
    description: "Document for application approval",
    type: "any",
    resourceType: "Application" /* APPLICATION */,
    hasExpirationDate: false
  },
  dic: {
    name: "dic",
    label: "DIC",
    description: "DIC document",
    type: "any",
    resourceType: "Cargo" /* CARGO */,
    hasExpirationDate: false
  },
  claris: {
    name: "claris",
    label: "CLARIS",
    description: "CLARIS document",
    type: "any",
    resourceType: "Cargo" /* CARGO */,
    hasExpirationDate: false
  },
  listOfDgr: {
    name: "listOfDgr",
    label: "List of the DGR",
    description: "List of DGR items",
    type: "any",
    resourceType: "Cargo" /* CARGO */,
    hasExpirationDate: false
  },
  codeShareStatement: {
    name: "codeShareStatement",
    label: "Code Share statement",
    description: "Statement for code sharing",
    type: "any",
    resourceType: "CodeShare" /* CODE_SHARE */,
    hasExpirationDate: false
  },
  feePaymentConfirmation: {
    name: "feePaymentConfirmation",
    label: "Fee payment confirmation",
    description: "Confirmation of fee payment",
    type: "any",
    resourceType: "Payment" /* PAYMENT */,
    hasExpirationDate: false
  }
};
var getDocumentTypeByName = (name) => DOCUMENT_TYPES[name];
var getDocumentTypesByResourceType = (resourceType) => Object.values(DOCUMENT_TYPES).filter(
  (dt) => dt.resourceType === resourceType
);
var getAllDocumentTypes = () => Object.values(DOCUMENT_TYPES);
var isBaseDocumentType = (name) => name in DOCUMENT_TYPES;
var organizationTypeToDocumentResourceType = (orgType) => {
  const mapping = {
    AIRLINE: "Airline" /* AIRLINE */
    // Future organization types:
    // BROKER: DocumentResourceType.BROKER,
  };
  return mapping[orgType] ?? "Airline" /* AIRLINE */;
};

export {
  DocumentResourceType,
  DOCUMENT_TYPES,
  getDocumentTypeByName,
  getDocumentTypesByResourceType,
  getAllDocumentTypes,
  isBaseDocumentType,
  organizationTypeToDocumentResourceType
};
